import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { initLenis, scrollToTop } from "@/lib/lenis";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { SearchOverlay } from "@/components/SearchOverlay";
import { SmsPopup } from "@/components/SmsPopup";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import AboutPage from "@/pages/AboutPage";
import { ShopPage } from "@/pages/Listing";

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => { scrollToTop(); }, [pathname]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const [search, setSearch] = useState(false);
  const closeSearch = useCallback(() => setSearch(false), []);
  useEffect(() => initLenis(), []);
  return (
    <>
      <ScrollReset />
      <div className="grain" aria-hidden="true" />
      <AnnouncementBar />
      <Header onSearch={() => setSearch(true)} />
      <main className="min-h-[60vh]">
        <ErrorBoundary key={pathname}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/products/:handle" element={<ProductPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        </ErrorBoundary>
      </main>
      <Footer />
      <CartDrawer />
      <SearchOverlay open={search} onClose={closeSearch} />
      <SmsPopup />
      <Toaster position="bottom-center" toastOptions={{ style: { borderRadius: 0, background: "#111111", color: "#F4F2EE", border: "none", fontFamily: "Geist" } }} />
    </>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Shell />
      </CartProvider>
    </BrowserRouter>
  );
}
